/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "client": {
        "nested": {
          "Buyer": {
            "fields": {
              "buyerId": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "fullName": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "photoUrl": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.client?.nested?.Buyer) {
  $root.addJSON(jsonData);
}

/**
 * Represents buyer information like name and photo_url.
 *
 * SOURCE Buyer @ squareup/client/buyer.proto at 16:1
 */
export const Buyer = $root.lookupType('squareup.client.Buyer');
fixType(Buyer, {
  buyerId: {
    required: true
  }
});
Builder.createAndAttachToType(Buyer);